(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["swatches"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__productCardSizeAddInit) return;
  window.__productCardSizeAddInit = true;

  function setInCartButtons(inCartIds) {
    document.querySelectorAll('.product-card__size-btn').forEach(function (b) {
      b.classList.toggle('is-in-cart', inCartIds.has(b.dataset.variantId));
    });
  }

  function refreshInCartStates() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var ids = new Set((cart.items || []).map(function (i) { return i.variant_id.toString(); }));
        setInCartButtons(ids);
      })
      .catch(function () {});
  }

  var refreshTimer;
  document.addEventListener('cart:update', function (e) {
    if (e.detail && e.detail.data && e.detail.data.source === 'product-card-quick-add') return;
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refreshInCartStates, 300);
  });

  document.addEventListener('click', async function (e) {
    if (!e.target) return;
    var btn = e.target.closest('.product-card__size-btn');
    if (!btn || btn.disabled || btn.classList.contains('is-loading')) return;

    e.preventDefault();
    e.stopPropagation();

    var variantId = parseInt(btn.dataset.variantId, 10);
    if (!variantId) return;

    btn.classList.add('is-loading');

    var sectionIds = Array.from(
      document.querySelectorAll('cart-items-component[data-section-id]')
    ).map(function (el) { return el.dataset.sectionId; }).filter(Boolean);

    try {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
          sections: sectionIds.join(','),
        })
      });

      if (!res.ok) {
        var errBody = await res.json().catch(function () { return {}; });
        throw new Error(errBody.description || 'Could not add to cart');
      }

      var data = await res.json();

      btn.classList.remove('is-loading');
      btn.classList.add('is-added');
      setTimeout(function () { btn.classList.remove('is-added'); }, 1500);

      document.querySelectorAll('.product-card__size-btn[data-variant-id="' + variantId + '"]').forEach(function (b) {
        b.classList.add('is-in-cart');
      });

      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: data,
          data: {
            source: 'product-card-quick-add',
            variantId: variantId.toString(),
            sections: data.sections || {},
          },
        },
      }));

      requestAnimationFrame(function () {
        var row = document.querySelector('.cart-items__table-row[data-variant-id="' + variantId + '"]');
        if (!row) return;
        row.classList.remove('cart-items__table-row--newly-added');
        void row.offsetWidth;
        row.classList.add('cart-items__table-row--newly-added');
      });

    } catch (err) {
      btn.classList.remove('is-loading');
      btn.classList.add('is-error');
      setTimeout(function () { btn.classList.remove('is-error'); }, 2000);
      console.error('[quick-add]', err.message);
    }
  }, true);
})();
  } catch(e) { console.error(e); }
})();

})();
